export type InputSize = "small" | "medium" | undefined;

export const inputStyles = {
  // Size medium
  "& .MuiInputBase-root": {
    height: "48px",
  },

  "& .MuiInputBase-input": {
    borderRadius: "8px",
    paddingTop: "12px",
    paddingBottom: "12px",
  },

  "& .MuiInputLabel-root": {
    top: "-3px",
    borderRadius: "5px 5px 0 0",
    backgroundColor: "white",
    zIndex: 1,
    padding: "0 8px",
  },
  "& .MuiInputLabel-shrink": {
    top: 0,
    borderRadius: "5px 5px 0 0",
    transform: "translate(10px, -9px) scale(0.75)",
    backgroundColor: "white",
    maxWidth: "100%",
  },

  // Size small
  "& .MuiInputBase-sizeSmall": {
    height: "40px",
    minHeight: "unset",
  },
  "& .MuiInputLabel-sizeSmall": {
    top: 0,
  },
  // Multiline
  "& .MuiInputBase-multiline": {
    padding: "4px 14px",
    minHeight: "48px",
    height: "auto",
  },

  "& .MuiInputBase-inputMultiline": {
    padding: 0,
  },

  "& .MuiOutlinedInput-root": {
    transition: "box-shadow 0.2s, border-color 0.2s",
    borderRadius: "8px",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5C4BAA",
      boxShadow: "0px 0px 0px 4px #5C4BAA1F",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5C4BAA",
      boxShadow: "0px 0px 0px 4px #5C4BAA1F",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    transition: "box-shadow 0.2s, border-color 0.2s",
    borderRadius: "8px",
  },
};

export const inputStylesMultiLine = {
  ...inputStyles,
  "& .MuiInputBase-root": {
    minHeight: 48,
    padding: "3px 9px",
  },
};
